export const columnNamesOrders = [
  '#',
  'מספר הזמנה',
  'תאריך פתיחה',
  'לקוחות',
  "מספר דוחות",
  "תאריך יעד",
  "סטטוס",
  "שם מלא",
  "נייד",
  "תפקיד",
  "ארגון",
  "מייל",
  "כתובת",
  "שם עו\"ד",
  "שולם",
  "לתשלום",
]

export const columnNamesUsersActions = [
  '#',
  'שם משתמש',
  'תאריך הפעולה',
  'השירות',
  'תיאור הפעולה',
  'דף',
  'נושא',
  'מידע נוסף',
  'תוצאת הפעולה',
]

export const columnNamesContacts = [
  '#',
  'מספר איש קשר',
  'שם מלא',
  'טלפון',
  'דוא',
  'תפקיד',
  'ארגון',
  'כתובת',
  'סטטוס',
]

export const columnNamesCustomers = [
  '#',
  'מספר לקוח',
  'שם',
  'טלפון',
  'דוא\"ל',
  'סוג לקוח',
  'מספר זהות',
  'מגדר',
  'סטטוס',
]

export const columnNamesTasks = [
  '#',
  'מספר משימה',
  'גורם מטפל',
  'מספר דוח',
  'סוג נכס',
  'סוג משימה',
  'סטטוס',
  'לקוחות',
  'כתובת',
  'תאריך לביצוע',
]

export const columnNamesPriceQuotes = [
  '#',
  'מספר הצעה',
  'תאריך יצירה',
  'לקוחות',
  'איש קשר',
  'סטטוס',
  'שכר טרחה',
  'נשלח',
  'תאריך נשלח',
  'סטטוס לקוח',
]

export const columnNamesInspections = [
  '#',
  'מספר דוח',
  'תאריך יצירה',
  'סטטוס',
  'לקוחות',
  'כתובת',
  'גוש / חלקה / תת חלקה',
  'מטרת הדוח/סוג דוח',
  'סוג נכס',
  'אומדן שווי',
  'מחיר מכירה',
  'שולם',
  'דמ”ש',
  'שטח רשום',
  'חדרים',
  'קומה',
  'מעלית',
  'גורם מטפל',
  'תאריך יעד'
]

export const columnNamesPriceCatalog = [
  '#',
  'מספר',
  'גורם מפנה',
  'סוג שמאות',
  'שם השירות',
  'מחיר',
  'הערות',
]

export const columnNamesNotifications = [
  '#',
  "זמן משלוח",
  "נושא",
  "השולח",
  "סוג",
  "נמען",
  "מסמך מקושר",
  "סטטוס",
]